const CashinCardPaymentSelection = {
  SavedCards: "saved-cards",
  TemporaryCard: "temporary-card",
};

export default CashinCardPaymentSelection;
